module.exports = function (fox) {
	'use strict';
	require('./stylus/_intercom.styl');
	require('./intercom');
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/intercom/index.js
// module id = 56
// module chunks = 5